<template>
    <div class="info_detail">
        <div class="header fr ac">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>
                    <a @click="redirect('/home/info')">知识库</a>
                </el-breadcrumb-item>
                <el-breadcrumb-item>文章详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="main fr">
            <div class="left">
                <div class="fc ac jc">
                    <p class="fz18 bold black">{{info_detail.information_title}}</p>
                    <div class="fz12 grey fr ac mt10">
                        <p>文章来源：{{info_detail.member_nick_name}}</p>
                        <p class="ml10">发表日期：{{info_detail.create_time}}</p>
                    </div>
                </div>
                <el-divider />
                <div class="info" v-html="info_detail.information_url_desc"></div>
            </div>
            <div class="right">
                <p>最新发布</p>
                <el-divider />
                <col-cell v-for="i in news_list" :key="i.information_id" :info="i" />
            </div>
        </div>
    </div>
</template>

<script>
import col_cell from "./InfoCell";
export default {
    data() {
        return {
            info_detail: {},
            news_list: []
        };
    },
    created() {
        this.getInformationDetail();
        this.getInformations();
    },
    watch: {
        $route(to, from) {
            this.getInformationDetail();
            this.getInformations();
        }
    },
    methods: {
        getInformationDetail() {
            this.post("informationInterfaces/v1.0/getInformationDetail", {
                information_id: this.$route.query.id
            }).then(res => {
                this.info_detail = res.data;
            });
        },
        // 获取常见问题
        getInformations() {
            let obj = {};
            obj.page = 1;
            obj.is_new = 1;
            this.post("/informationInterfaces/v1.0/getInformations", obj).then(
                res => {
                    this.news_list = res.data;
                }
            );
        }
    },
    components: { "col-cell": col_cell }
};
</script>

<style lang="scss">
.info_detail {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;
    .header {
        padding-left: 20px;
        width: 100%;
        height: 40px;
        background-color: #fff;
        margin-bottom: 20px;
    }
    .main {
        width: 100%;
        .left {
            width: 800px;
            background-color: #fff;
            padding: 20px;
            .info {
                width: 100%;
                img {
                    max-width: 100% !important;
                }
            }
        }
        .right {
            width: calc(100% - 820px);
            margin-left: 20px;
            padding: 20px;
            background-color: #fff;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/homePage/homeInfo/detail.vue